module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "div_autre"
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-002"
    }
  }, [_c('div', {
    staticClass: "fond"
  }, [_c('h1', {
    staticClass: "pre_surtit"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("Introduction")])])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('h1', {
    staticClass: "pre_tit"
  }, [_c('span', [_vm._v("An Invitation to Discover"), _c('br'), _vm._v("\n      Strength in Weakness")])]), _vm._v(" "), _c('h1', {
    staticClass: "pre_stit"
  }, [_c('span', [_vm._v("The most excellent way")])])])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('div', {
    staticClass: "dev"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE MOST DYNAMIC SPIRITUAL LEADERS ")])]), _vm._v("know they are both saint and sinner. Or, as Martin Luther noted long ago, "), _c('i', [_vm._v("“Simul iustus et peccator”")]), _vm._v("—at the same time righteous and sinner. These leaders live with a burning desire to be honest about themselves—acknowledging their strengths as well as their struggles and mishaps. They live and lead from the depth of their soul, which is the essence of their existence. And, as a result, they become more attuned to an experiential knowledge of the truth about God and others within their reach.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Healthy spiritual leaders recognize the reality of living in the tension of the already-and-not-yet nature of the kingdom. They expect to experience both transformative redemption "), _c('i', [_vm._v("and")]), _vm._v(" continued brokenness in their generational lifetime. They know that Christ’s kingdom has been inaugurated and is being realized here on earth. But their complete redemption is not fully consummated until they are ushered into God’s kingdom for all eternity.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("As continuously redeemed and transformed beings, they experience the abundant life of Christ with ever-increasing joy and thereby invite others around them to do likewise. Leaders who embrace their brokenness and submit it authentically into the hands of God are the ones who marvel at God’s redemptive work and serve others with renewed passion. Their spiritual eyesight is likened to Saint Augustine, who once said, “In my deepest wound I saw your glory, and it dazzled me.” They are an inspiration to all.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Consider this perspective on leadership as portrayed in the biblical text. For example, where would the story of Joseph’s tested faithfulness be without the jealousy of his brothers or the lure from Potiphar’s wife? Would we know about the leader Moses without his excuse of a speech impediment and shirking responsibilities? And—oh by the way—what about his murder of an Egyptian? Wasn’t Rahab the harlot an instrument of grace for Joshua? What about Saul’s blatant hatred of Christians before being blinded by the light on the road to Damascus? And would we know the full gospel story without Jesus suffering from ridicule, beatings, humiliation and the excruciating pain of a broken body and shed blood on the cross?")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("I am profoundly motivated when I think of the woman who was abused by her mother growing up and who now serves as a mentor to young moms. I’m deeply touched by the severely disabled woman who is a faithful servant leader, stuffing envelopes and fervently praying for missionaries in the agency where she volunteers time and resources. I’m awestruck by the former drug addict and ex-con who now is clean and sober and leading troubled youth to Christ. I’m moved by the fallen leader who, once caught in a web of lies and an adulterous relationship, is back with his wife and together serving couples in marital difficulty. I’m equally delighted when I meet many other leaders who are ")]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("simply willing to own their brokenness, no matter how messy or complex, and who humbly submit that weakness into the hands of Almighty God to become a redeemed strength unlike any of their natural abilities.")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-001"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LESSED AND ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROKEN")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("I’m dearly loved by my heavenly Father and I’m deeply sinful—how can the two go together?")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I’ve been a leader myself for nearly four decades. I’ve had the privilege of serving others in local church, parachurch and nonprofit environments. I’ve experienced great success and a few embarrassing failures. I’ve seen incredible highs and a handful of deep lows. I’ve considered myself effective and I’ve watched myself tire into utter exhaustion. I’ve brought others a lot of joy and I’ve both dished out and received from others my share of disappointment. In essence, as much as I like to view myself as a good or even a very good leader, I’m more truthfully a blessed and broken leader, one who is daily in need of being restored and renewed, refreshed and redeemed by the Spirit of God who resides in me.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Basically, I’ve come to grips with the reality that I am who I am. I’m a new creation in Christ Jesus. I have made many positive contributions as a leader. I’ve served faithfully as a pastor in a large and healthy church. I’ve experienced effectiveness as a leader of a one-hundred-year-old organization that grew significantly in my tenure. I’ve mentored many young and aspiring leaders. I’ve even founded a ministry that’s been richly blessed by God.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("But I also make mistakes. I blunder. I think horrible thoughts. I’m an internal quagmire more often than I desire and in continual need of God’s grace. I know what it feels like to be a manipulator, and when not kept in check I can drive myself and ")]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("others crazy with my perfectionistic tendencies. I’ve been deeply hurt by past failures. I’ve been disappointed by the attitudes and actions of others. And I see these same things in many others who are in leadership positions in the body of Christ.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I’ve discovered that when I’m authentic, honest and transparent about "), _c('i', [_vm._v("all")]), _vm._v(" my realities as a leader, I can relax more in the presence of those who previously intimidated me. I can laugh more at my own imperfections. I can live in a deep place of freedom and joy. Most importantly, I can embrace my brokenness, befriend it, and watch and wait in trust for God to birth hope in my heart for the redemptive way forward. In essence, by living in this reality I can experience the fullness of a loving God and the richness of an emancipated consciousness that leads me into genuine freedom and joy.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I’m willing to embrace my own blessed and broken reality. I know that my Almighty God sees me as his dearly loved, graced and gifted child, and he sees me at my worst when I’m a disheartened follower or a disobedient sinner. And he loves me no matter what state I’m in. I can trust his Spirit to redeem the reality of my brokenness, and I can live in the hope of the resurrection, willing to die to myself, live fully for God, and offer myself as a living sacrifice to all who cross my path in life and service. There’s no better way to live and lead.")])])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-002"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELCOME TO THE ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OURNEY")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("So I ask you: What’s your choice as a leader today? Will you confess your own belovedness and blessedness as well as your brokenness?")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("If so, I invite you to join me in entering into the truth about the abundant life we have as dearly loved and richly blessed Christ-followers and to embrace our brokenness as human beings in constant need of God’s grace. For the sake of this book, ")]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("and with no intention to standardize these categories, I’m using "), _c('i', [_vm._v("brokenness")]), _vm._v(" or "), _c('i', [_vm._v("weakness")]), _vm._v(" as overarching terms. Underneath those terms are four subsets to note, representing both internal brokenness (our own sinful choices and painful misfortunes) and external brokenness (the effect of others’ sin on us and the impact of our world’s large calamities):")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('ol', {
    staticClass: "liste_num"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("Suffering—physical disabilities, emotional illness, societal misfortune, catastrophic events, inflicted without your individual or human choice")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("Heartache—physical or emotional abuse, disappointments in others or in life circumstances (mistakes, struggles, mishaps and shortcomings), shame and guilt, or relational discord afflicted by others and/or contributed also by you")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("Sinfulness—prideful choices you’ve made that create internal or external pain for yourself and/or others and that reflect outright disobedience to God, regardless of motivation or rationale")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("Imperfections—those areas of your life that seem to follow you daily, such as your idiosyncratic behaviors, nagging habits and plaguing mind games that keep you up at night")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I will lead the way by telling you the truth about me. I’m willing to do this because I’m concerned about the growing need for authentic Christian leadership today. And, I’m alarmed at how many are allergic to doing the hard work of looking deep within to discover their true selves and upward to God for his unique blessing on their lives. Instead, many leaders are living unfulfilled lives without really knowing why. Some are simply unwilling to confess their brokenness or acknowledge their weakness. Others are looking for the perfect leader somewhere “out there” to emulate.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Many want to follow leaders who appear put together; we want to be tutored by them in order to look and sound like them. We will do whatever it takes to reach their perceived status and recognition. We read their books, attend their conferences, practice their programs, buy their products and begin to speak like them (sometimes even exploiting their published sermons and teaching outlines). We want to somehow acquire their strength without considering the cost they too have paid (and the suffering they endured) in addressing their own brokenness and seeing how God has redeemed it and continues to redeem it for his glory.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We long to have what others have earned. We dream about our walls being filled with the same framed accolades these emulated leaders have achieved. We measure ourselves against the success of others. Yet the upward ascent to greatness feels more like pushing a rock uphill, and we are forced to work all the harder so we aren’t found out as a failure, a fraud or a quitter.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I’m convinced that the true pursuit of greatness as a leader begins and continues in the gentle humility that accompanies our sincere confession of brokenness and the accompanying need for God to heal, redeem and strengthen us from the inside out. My simple invitation in this book is for you to confess your brokenness in the context of your belovedness and your blessedness—not just once but on an ongoing basis—and then to lead others as you have been led by God: in love.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("By giving voice and words to your brokenness, you can indeed experience the depth of soul and vitality of service you’ve longed for, though it will most likely look much different from what you could ever ask, dream or imagine today. Strength will emerge out of weakness—if you prayerfully submit all of yourself in trust to God. Best of all: the true you will emerge like never before, as you become all that God intends.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Therefore, let’s remember with gratefulness Paul’s paradoxical insights in 2 Corinthians 12:9-10:")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("“My grace is sufficient for you, for my power is made perfect in weakness.” Therefore I will boast all the more gladly about my weaknesses, so that Christ’s power may rest on me. That is why, for Christ’s sake, I delight in weaknesses, in insults, in hardships, in persecutions, in difficulties. For when I am weak, then I am strong.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("God delights to welcome you with his loving embrace into a countercultural way of leading and following—from a broken and redeemed heart overflowing with humility, grace and love. Then and only then will you be made whole.")])])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-003"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OST ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XCELLENT ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AY ")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In the book of 1 Corinthians, the apostle Paul writes lovingly and directly to a troubled and broken church and invites its leaders to allow God’s love to heal, redeem and transform them from the inside out. Paul speaks very specifically into their brokenness: divisions in the church, immorality among the brethren, lawsuits among believers, sexual immorality, inappropriate understandings of marriage, food being sacrificed to idols, propriety in worship and the Lord’s Supper, and exercising of spiritual gifts. He brings all of it out into the open, inviting the church in Corinth to embrace its brokenness and lean fully into restoration, redemption and renewal. Only then will they become healthy and whole.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("The apex of Paul’s first letter to the Corinthian church leaders is chapter 13. It is most often read at marriage ceremonies—and appropriately so, since the “love chapter” is chock full of words and phrases to be displayed in our marriages and homes—but Paul’s original intention was to invite the leaders and the entire ")]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("community of faith in Corinth to live as one in Christ in this “most excellent way.” Instead of competitively hyping or disregarding one another’s particular gifts to the fellowship and continuously living in a state of disunity, Paul urges them to move beyond their differences into a harmony defined by love.")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("And now I will show you the most excellent way. . . . Love is patient, love is kind. It does not envy, it does not boast, it is not proud. It is not rude, it is not self-seeking, it is not easily angered, it keeps no record of wrongs. Love does not delight in evil but rejoices with the truth. It always protects, always trusts, always hopes, always perseveres. Love never fails. . . . And now these three remain: faith, hope and love. But the greatest of these is love. (1 Corinthians 13:1, 4-8, 13)")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We will explore together the sixteen words or phrases Paul uses to describe the most excellent way of love (from 1 Corinthians 13), and we will look at the dark undersides of each phrase to identify our propensity toward brokenness and weakness as distortions of God’s love. When we discover that God is truly and forever love, then our restoration and transformation process belongs solely to him. When we learn to surrender to God as love and begin to live into his redemptive love, we embrace both our strengths and our brokenness and lead others in a radically different way.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("At the end of each chapter you will be encouraged to confess your own brokenness and engage in a soul audit that invites your truthful response. Here you will discover the value of time spent in self-reflection, considering how best to “be still, and know that I am God” (Psalm 46:10). And in this spacious place of stillness you will know how, as Richard Meux Benson, founder of the Society of Saint John the Evangelist, once said, “the Spirit accommodates Himself to our littleness that we may expand to ")]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("His greatness.” In that process you will begin to know yourself and those you serve with a greater depth of insight and wisdom. In addition, you will be encouraged to prayerfully consider how God is inviting you to assess your current ways of living in order to embrace a new way of following Jesus and leading others in his name.")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Along the way I urge you to be gentle with your honesty, faithful in your authenticity and hopeful in your redemption. The confessions ahead of us will be good for our souls. Let’s leave behind our hiding and hopelessness and enter the pathway to the abundant life of Christian leadership and followership with prayerful anticipation and joyful expectation.")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30defbe2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre3.vue
// module id = 72
// module chunks = 0